import { RegistrationCommonInputProps } from 'features/registration/interface/registration';
import { FC } from 'react';
import FormRow from 'shared/components/form/formRow';
import InputText from 'shared/components/form/inputText';
import useInputFocus from 'shared/hooks/useInputFocus';
import { disableInputNumbers } from 'shared/util/utility';

const RegistrationStep1: FC<RegistrationCommonInputProps> = ({ isFieldValueValid, errors, touched, setFieldValue, values, handleBlur, t }) => {
	const inputRef = useInputFocus();
	return (
		<FormRow>
			<InputText
				autoFocus
				inputRef={inputRef}
				label={t('firstName')}
				name="firstName"
				isFieldValueValid={isFieldValueValid}
				errors={errors}
				touched={touched}
				onBlur={handleBlur}
				setFieldValue={setFieldValue}
				values={values}
				onChange={(e) => setFieldValue('firstName', disableInputNumbers(e))}
				cyTestRef="first-name"
				cyErrorRef="reg-validation-error"
			/>
		</FormRow>
	);
};

export default RegistrationStep1;
